import React from 'react';
import { Link } from 'react-router-dom';

const SelectPromotionType: React.FC = () => {
  return (
    <div className="p-10">
      <h1>Select Promotion Surface</h1>
      <Link
        className="flex flex-col items-start w-1/2 text-xl py-4 px-8 text-black border border-black mt-4"
        to="/promotions/create-funnel-promotion"
      >
        <span className="font-bold py-2">Funnel</span>
        <span className="text-sm py-2">
          Add a promotional product to a <span className="font-bold">trial</span> order
        </span>
      </Link>
      <Link
        className="flex flex-col items-start justify-center w-1/2 text-xl py-4 px-8 text-black border border-black mt-4"
        to="/promotions/create-portal-promotion"
      >
        <span className="font-bold py-2">Customer Portal</span>
        <span className="text-sm py-2">
          Add a promotional product to a <span className="font-bold">subscription</span> order
        </span>
      </Link>
      <Link
        className="flex flex-col items-start justify-center w-1/2 text-xl py-4 px-8 text-black border border-black mt-4"
        to="/promotions/create-reactivation-promotion"
      >
        <span className="font-bold py-2">Reactivation</span>
        <span className="text-sm py-2">
          Add a promotional product to a <span className="font-bold">reactivation</span> order
        </span>
      </Link>
    </div>
  );
};

export default SelectPromotionType;
